import React, { useContext, useEffect, useState, useRef, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import { KeyboardArrowDown, KeyboardArrowRight } from "@material-ui/icons";
import { IconButton, Typography } from "@material-ui/core";
import servicesService from "~/services/servicesService";
import couponServices from "~/services/couponServices";
import businessService from "~/services/businessService";
import { packagesList } from "~/services/packagesServices";
import { buildPackageLabel } from "~/utils/packages";
import VendorAddPet from "~/views/VendorAddPet";
import VendorCategorieScheduling from "~/views/VendorCategorieScheduling";
import VendorRegisteredPet from "~/views/VendorRegisteredPet";
import { ModalBottom } from "~/components/common/modalBottom/modalBottom";
import { DialogBuilder } from "~/utils/DialogProvider";
import { useTranslation } from "react-i18next";
import FeaturesSelected from "~/components/common/featuresSelected/FeaturesSelected";
import PurpleCheckBox from "~/components/common/purpleCheckBox/purpleChackBox";
import ScheduleDiv from "~/components/common/scheduleDiv/ScheduleDiv";
import ErrorDialog from "~/components/common/dialog";
import Utils from "~/helpers/Utils";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import _ from "lodash";
import useStyles from "~/views/VendorServiceScheduling/styles";
import timeIcon from "assets/icons/group-4.png";
import CustomLoading from "~/components/common/customLoading/customLoading";
import PurpleButton from "~/components/common/purpleButton/PurpleButton";

const VendorCategoryServices = (props) => {
	const {
		business,
		coupon,
		showFullAddress,
		category,
		showVendorDescription,
		setShowVendorDescription,
		quantityCategories
	} = props;
	const { t, i18n } = useTranslation();
	const dialog = useContext(DialogBuilder);
	const location = useLocation();
	const { user } = useSelector((store) => store.auth);
	const { me: meStore } = useSelector((store) => store.me);
	const queryParams = new URLSearchParams(location.search);
	const serviceId = queryParams.get("serviceId");
	const categoryId = queryParams.get("categoryId");

	const me = Utils.safeParseJSON("@prit-web/meData", meStore) || meStore;

	const classes = useStyles();

	const [selectedCategory, setSelectedCategory] = useState(
		categoryId
			? {
					categoty: {
						id: categoryId,
					},
			  }
			: category
	);
	const [showPetRegister, setShowPetRegister] = useState(false);
	const [selectedPet, setSelectedPet] = useState();
	const [show, setShow] = useState("");
	const [showPackages, setShowPackages] = useState(false);
	
	// Estado para controlar a animação do modal
	const [animationTrigger, setAnimationTrigger] = useState(0);

	const [selectedServices, setSelectedServices] = useState([]);
	const [openedBranchs, setOpenedBranchs] = useState([]);
	const [search, setSearch] = useState("");
	const [treeView] = useState(false);
	const [openError, setOpenError] = useState(false);
	const [levelPath, setLevelPath] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(0);

	const pet = selectedCategory?.categorie?.pet;
	const [readyService, setReadyService] = useState(false);
	const [loading, setLoading] = useState(true);
	const [services, setServices] = useState([]);
	const [servicesTree, setServicesTree] = useState([]);
	const [currentLevel, setCurrentLevel] = useState([]);
	const [packageLabelMap, setPackageLabelMap] = useState({});

	const selectedServicesScrollRef = useRef(null);

	const storageLanguage = sessionStorage.getItem("@prit-web/language");
	const language = storageLanguage ?? business?.language;

	const currentUser = me || user || {};
	const isOwnerUser =
		!_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;

	const openBranch = (branch) => {
		setOpenedBranchs([...openedBranchs, branch.id]);
	};

	const closeBranch = (branch) => {
		setOpenedBranchs(
			openedBranchs.filter((openedBranch) => {
				return openedBranch !== branch.id;
			})
		);
	};

	const isOpen = (branch) => {
		return openedBranchs.includes(branch.id);
	};

	const handleSchedule = () => {
		if (selectedServices.length > 0) {
			if (isOwnerUser) {
				const serviceNamesSelected = selectedServices
					.map((s) => s.serviceName)
					.sort((a, b) => a.localeCompare(b))
					.join(", ");
				mixpanelTrackEvent(
					"Avancou_Em_Agendar",
					{ Servicos_Selecionados: serviceNamesSelected },
					currentUser,
					business
				);
			}
			props.history.push(`/selecionar-data/${business.id}`, {
				services: selectedServices,
				coupon: coupon,
				// feature_items: feature_items,
			});
		} else {
			if (isOwnerUser) {
				mixpanelTrackEvent(
					"Tentativa_Avancar_Agendar",
					{ Erro_Disparado: "Serviço não selecionado" },
					currentUser,
					business
				);
			}
			handleModalServices();
			window.scrollTo(0, window.innerHeight);
		}
	};

	const handleModalServices = () => {
		setShow("services");
	};

	const handleSelectService = (item) => {
		if (item.selected) {
			setSelectedServices(selectedServices.filter((service) => service.id !== item.id));
		} else {
			setSelectedServices([...selectedServices, item]);
			setTimeout(() => {
				if (selectedServicesScrollRef.current) {
					selectedServicesScrollRef.current.scrollTo({
						left: selectedServicesScrollRef.current.scrollWidth,
						behavior: 'smooth'
					});
				}
			}, 100);
		}
	};

	const removeSelectedService = (item) => {
		setSelectedServices(selectedServices.filter((service) => service.id !== item.id));
	};

	const isServiceSelected = (item) => !!item && selectedServices.some((service) => service.id === item.id);

	const goToLevel = (branch) => {
		const { path, level } = servicesService.expandSingleGroupLevels(branch?.branchs);
		setLevelPath((prev) => [...prev, branch, ...path]);
		setCurrentLevel(level);
		setAnimationTrigger((prev) => prev + 1);
	};

	const showTreeRoot = (tree) => {
		const { path, level } = servicesService.expandSingleGroupLevels(tree);
		setLevelPath(path);
		setCurrentLevel(level);
	};

	const renderBranch = (branch) => {
		let selectable = branch?.branchs?.length === 0;

		return (
			<>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						padding: "12px",
						borderBottom: "1px solid #eee",
						cursor: selectable ? "pointer" : "default",
					}}
					onClick={() => {
						if (selectable) {
							handleSelectService(branch);
						} else {
							if (isOpen(branch)) {
								closeBranch(branch);
							} else {
								openBranch(branch);
							}
						}
					}}>
					<div style={{ flex: 1 }}>
						<div style={{ display: "flex", alignItems: "center" }}>
							{selectable ? (
								<PurpleCheckBox
									checked={selectedServices.some((service) => service.id === branch.id)}
									onChange={() => handleSelectService(branch)}
								/>
							) : (
								<IconButton
									size="small"
									onClick={(e) => {
										e.stopPropagation();
										if (isOpen(branch)) {
											closeBranch(branch);
										} else {
											openBranch(branch);
										}
									}}>
									{isOpen(branch) ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
								</IconButton>
							)}
							<span style={{ marginLeft: "8px", fontWeight: "500" }}>{branch.name}</span>
						</div>
						{branch.description && (
							<div style={{ marginLeft: "32px", fontSize: "14px", color: "#666" }}>{branch.description}</div>
						)}
					</div>
					{selectable && branch.price && (
						<div style={{ marginLeft: "auto", fontWeight: "bold" }}>{Utils.formatCurrency(branch.price)}</div>
					)}
				</div>
				{isOpen(branch) &&
					branch.branchs?.map((subBranch) => (
						<div key={subBranch.id} style={{ marginLeft: "20px" }}>
							{renderBranch(subBranch)}
						</div>
					))}
			</>
		);
	};

	const findServiceById = (branchs, serviceId) => {
		for (let branch of branchs) {
			if (branch.id === serviceId) return branch;
			if (branch.branchs) {
				const found = findServiceById(branch.branchs, serviceId);
				if (found) return found;
			}
		}
		return null;
	};

	const autoSelectIfSingleService = (tree) => {
		const getAllLeafServices = (branches, path = []) => {
			let results = [];
			for (const branch of branches) {
				if (!branch?.branchs || branch.branchs.length === 0) {
					if (branch?.service) {
						results.push({ branch, path });
					}
				} else {
					results = results.concat(getAllLeafServices(branch.branchs, [...path, branch]));
				}
			}
			return results;
		};

		const leafServices = getAllLeafServices(tree);

		if (leafServices.length === 1) {
			const { branch, path } = leafServices[0];
			setSelectedServices((prev) => {
				if (!branch.service || prev.some((s) => s.id === branch.service.id)) return prev;
				return [...prev, branch.service];
			});
			if (path.length > 0) {
				setLevelPath(path);
				setCurrentLevel(path[path.length - 1].branchs);
			}
		}
	};

	const shouldAutoSelectService = (branch) => {
		if (!branch?.branchs || branch.branchs.length === 0) {
			return null;
		}

		const getAllSelectableServices = (branches) => {
			let services = [];
			
			branches.forEach(subBranch => {
				if (subBranch?.branchs?.length === 0 && subBranch?.service) {
					services.push(subBranch);
				} else if (subBranch?.branchs?.length > 0) {
					services = services.concat(getAllSelectableServices(subBranch.branchs));
				}
			});
			
			return services;
		};

		const selectableServices = getAllSelectableServices(branch.branchs);

		if (selectableServices.length === 1) {
			return selectableServices[0];
		}

		return null;
	};

	const showButtonSelectServices = () => {
		const servicesBranchs = servicesTree.filter((service) => service?.branchs?.length > 0);
		if (quantityCategories > 1 || (servicesBranchs && servicesBranchs.length > 0)) return true;

		return false
	}

	const renderLevel = () => {
		let orderedCurrentLevel = currentLevel.filter((service) => !!service?.name).slice();

		orderedCurrentLevel.sort((a, b) => a.name.localeCompare(b.name));
		return orderedCurrentLevel.map((branch) => {
			let selectable = branch?.branchs?.length === 0;
			let value = branch?.service;
			let isChecked = isServiceSelected(value);

			return (
				<Fragment key={branch?.id}>
					{branch?.name !== "null" && branch?.name !== null && (
						<div
							className={classes.levelTileDiv}
							onClick={() => {
								if (selectable) {
									if (isServiceSelected(branch.service)) {
										removeSelectedService(branch.service);
									} else {
										handleSelectService(branch.service);
									}
								} else {
									const singleService = shouldAutoSelectService(branch);
									
									if (singleService) {
										if (!isServiceSelected(singleService.service)) {
											handleSelectService(singleService.service);
											
											if (isOwnerUser) {
												mixpanelTrackEvent(
													"Servico_Selecionado_Automaticamente",
													{ 
														Categoria: branch?.name,
														Servico: singleService?.service?.serviceName || singleService?.name
													},
													currentUser,
													business
												);
											}
										}
									}

									goToLevel(branch);
								}
							}}>
							<div
								key={branch?.id}
								className={classes.containerService}
								style={{
									backgroundColor: `${isChecked ? "" : ""}`,
								}}>
									<div style={{ display: "flex", width: "100%", alignItems: "flex-start", padding: "8px 0", gap: 4 }}>
										{/* Checkbox */}
										{selectable && (
											<div style={{ flexShrink: 0, marginTop: 2 }}>
												<PurpleCheckBox
													checked={isChecked}
													style={{ color: isChecked ? "#672E37" : "rgba(0,0,0,0.2)" }}
												/>
											</div>
										)}
										{/* Content column: takes all available space */}
										{(() => {
											// Preço em duas linhas ("A partir de" / "Preço no local"): a duração sobe
											// para logo abaixo do nome e o rótulo de pacote desce para baixo do preço.
											const priceTwoLines =
												!!value &&
												((Utils?.startsAtPricingTypeNames?.includes(value?.pricingTypeName) && !!value?.price) ||
													Utils.getServicePricingType(value, business, t) === t("Upon consultation"));
											const nameNode = (
												<h4
													translate="no"
													className={classes.nameList}
													style={{ fontSize: "clamp(16px, 2vw, 18px)", fontWeight: 500, margin: 0, lineHeight: 1.3, flex: 1, minWidth: 0 }}>
													{branch?.name}
												</h4>
											);
											const priceNode = (
												<div style={{ flexShrink: 0, paddingRight: 5 }}>
													{!selectable && (
														<KeyboardArrowRight style={{ fontWeight: 200, color: "rgba(0,0,0,0.3)" }} />
													)}
													{value && (
														Utils?.startsAtPricingTypeNames?.includes(value?.pricingTypeName) ? (
															value?.price ? (
																<div style={{ display: "flex", flexDirection: "column", textAlign: "right" }}>
																	<span style={{ fontSize: "clamp(12px, 2vw, 13px)", fontWeight: 400, color: "rgba(0,0,0,0.55)", lineHeight: 1.2 }}>
																		{t("Starts at")}
																	</span>
																	<span style={{ fontSize: "clamp(15px, 2vw, 16px)", fontWeight: 600, color: "#672E37", lineHeight: 1.2 }}>
																		{Utils.formatMoney((value.price / 100), business.currency)}
																	</span>
																</div>
															) : null
														) : (
															<span
																translate="no"
																style={{
																	fontSize: "clamp(15px, 2vw, 16px)",
																	fontWeight: 600,
																	color: "#672E37",
																	whiteSpace: Utils.getServicePricingType(value, business, t) === t("Upon consultation") ? "pre-line" : "normal",
																	textAlign: "right",
																	lineHeight: 1.3,
																}}
															>
																{Utils.getServicePricingType(value, business, t) === t("Upon consultation")
																	? t("Upon\nconsultation")
																	: Utils.getServicePricingType(value, business, t)}
															</span>
														)
													)}
												</div>
											);
											const durationNode = (
												<div style={{ display: "flex", alignItems: "center", gap: 4 }}>
													<img src={timeIcon} alt="time" style={{ width: 12, height: 12 }} />
													<Typography style={{ fontSize: "clamp(12px, 2vw, 13px)", fontWeight: 400, color: "rgba(0,0,0,0.55)", margin: 0, lineHeight: 1.2 }}>
														{Utils.formatMinutes(value?.duration)}
													</Typography>
												</div>
											);
											const labelNode = packageLabelMap[value?.id] && (
												<Typography style={{ fontSize: "clamp(12px, 2vw, 13px)", fontWeight: 400, color: "#A8848C", margin: 0, lineHeight: 1.2, textAlign: "right" }}>
													{packageLabelMap[value.id].multipleOffers
														? t("packageLabelFrom", { price: Utils.formatMoney(packageLabelMap[value.id].pricePerSession, business.currency) })
														: t("packageLabel", { price: Utils.formatMoney(packageLabelMap[value.id].pricePerSession, business.currency) })}
												</Typography>
											);

											if (priceTwoLines) {
												return (
													<div style={{ flex: 1, minWidth: 0 }}>
														<div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
															<div style={{ flex: 1, minWidth: 0 }}>
																{nameNode}
																{/* note */}
																{selectable && value?.note && (
																	<Typography style={{ fontSize: "clamp(12px, 2vw, 13px)", fontWeight: 400, color: "rgba(0,0,0,0.55)", marginTop: 4, lineHeight: 1.3 }}>
																		{value.note}
																	</Typography>
																)}
																{selectable && <div style={{ marginTop: 4 }}>{durationNode}</div>}
															</div>
															{priceNode}
														</div>
														{selectable && labelNode && (
															<div style={{ display: "flex", justifyContent: "flex-end", marginTop: 4, paddingRight: 5 }}>
																{labelNode}
															</div>
														)}
													</div>
												);
											}

											return (
												<div style={{ flex: 1, minWidth: 0 }}>
													{/* Row 1: name + price */}
													<div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
														{nameNode}
														{priceNode}
													</div>
													{/* Row 2: note */}
													{selectable && value?.note && (
														<Typography style={{ fontSize: "clamp(12px, 2vw, 13px)", fontWeight: 400, color: "rgba(0,0,0,0.55)", marginTop: 4, lineHeight: 1.3 }}>
															{value.note}
														</Typography>
													)}
													{/* Row 3: duration (left) + package label (right, under price) */}
													{selectable && (
														<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 4, paddingRight: 5 }}>
															{durationNode}
															{labelNode}
														</div>
													)}
												</div>
											);
										})()}
									</div>
							</div>
						</div>
					)}
				</Fragment>
			);
		});
	};

	useEffect(() => {
		if (selectedServicesScrollRef.current && selectedServices.length > 0) {
			setTimeout(() => {
				if (selectedServicesScrollRef.current) {
					selectedServicesScrollRef.current.scrollTo({
						left: selectedServicesScrollRef.current.scrollWidth,
						behavior: 'smooth'
					});
				}
			}, 150);
			
			setTimeout(() => {
				if (selectedServicesScrollRef.current) {
					selectedServicesScrollRef.current.scrollLeft = selectedServicesScrollRef.current.scrollWidth;
				}
			}, 400);
		}
	}, [selectedServices]);

	useEffect(() => {
		if (selectedServices.length > 0) {
			setCurrentIndex(selectedServices.length - 1);
		} else {
			setCurrentIndex(0);
		}
	}, [selectedServices]);

	const getTitle = (show) => {

		if (!category && !selectedCategory && props.readyCategories) {
			return t("Select Category");
		}
		
		if (!show) return t("");
		
		const title = {
			services: t("Choose the services to schedule"),
			packages: t("Select Package"),
		};
		return title[show];
	};

	const handleCategorySelection = (category) => {
		setSelectedCategory(category);
		setAnimationTrigger(prev => prev + 1);
	};

	const handleSetShow = (newShow) => {
		setShow(newShow);
		setAnimationTrigger(prev => prev + 1);
	};

	const handleSetShowPackages = (newShowPackages) => {
		setShowPackages(newShowPackages);
		setAnimationTrigger(prev => prev + 1);
	};

	const handleSetLevelPath = (newLevelPath) => {
		setLevelPath(newLevelPath);
		setAnimationTrigger(prev => prev + 1);
	};

	const handleSetCurrentLevel = (newCurrentLevel) => {
		setCurrentLevel(newCurrentLevel);
		setAnimationTrigger(prev => prev + 1);
	};

	const isLastServiceLevel = () => {
		if (!currentLevel || currentLevel.length === 0) {
			return false;
		}
		
		return currentLevel.some(service => 
			!service?.branchs || service.branchs.length === 0
		);
	};

	const handleGoBack = () => {
		const previous = levelPath.length > 0 ? servicesService.getPreviousLevel(servicesTree, levelPath) : null;

		if (previous) {
			setLevelPath(previous.path);
			setCurrentLevel(previous.level);
			setAnimationTrigger(prev => prev + 1);
		} else if (show === "services") {
			setLevelPath([]);
			setSelectedCategory(null);
			setSelectedServices([]);
			setAnimationTrigger(prev => prev + 1);
		} else if (selectedPet) {
			setSelectedPet(null);
			setSelectedServices([]);
			setAnimationTrigger(prev => prev + 1);
		}
	};

	const handleSelectMoreServices = () => {
		if (quantityCategories > 1) {
			setLevelPath([]);
			setSelectedCategory(null);
			setAnimationTrigger(prev => prev + 1);
		} else if (levelPath.length > 0) {
			showTreeRoot(servicesTree);
			setAnimationTrigger(prev => prev + 1);
		} else {
			setSelectedCategory(null);
			setAnimationTrigger(prev => prev + 1);
		}
	};

	const shouldShowBackButton = () => {
		if (!category && !selectedCategory && !selectedPet && !show) {
			return false;
		}
		
		return (
			levelPath.length > 0 || 
			show === "services" ||  
			selectedPet             
		);
	};

	const getBusinessServices = async () => {
		setLoading(true);
		if (business?.id) {
			if (coupon) {
				couponServices
					.getBusinessServiceCoupons(
						business.id,
						selectedCategory?.categorie?.id || business.categories?.[0]?.id,
						coupon.coupon.coupon_id,
						pet?.featureNames[0],
						pet?.featureNames[1]
					)
					.then((res) => {
						let businessServices = res.data;
						if (businessServices) {
							setServices(businessServices);
							let tree = servicesService.buildServiceTree(businessServices, business.language);
							if (pet) {
								tree = servicesService.petPreselection(tree, pet);
							}
							setServicesTree(tree ?? []);
							if (pet) {
								setCurrentLevel(tree ?? []);
							} else {
								showTreeRoot(tree ?? []);
							}
							autoSelectIfSingleService(tree ?? []);
						}
					})
					.catch((err) => {
						dialog
							.withTitle(t("Unable to load the services"))
							.withMessage(err.message)
							.withAction(() => props.history.goBack())
							.show();
						setLoading(false);
					})
					.finally(() => {
						setReadyService(true);
						setLoading(false);
					});
			} else {
				businessService
					.getBusinessService(
						business.id,
						selectedCategory?.categorie?.id,
						business.language,
						pet?.featureNames[0],
						pet?.featureNames[1]
					)
					.then((res) => {
						let businessServices = res.data;
						if (businessServices) {
							setServices(businessServices);
							let tree = servicesService.buildServiceTree(businessServices, language);
							if (tree && tree.length === 0) {
								mixpanelTrackEvent(
									"Business_Sem_Servicos",
									{ 	
									  categoria_selecionada: selectedCategory?.categorie?.name,
									  category_id: selectedCategory?.categorie?.id
									},
									currentUser,
									business
								);
							}
							setServicesTree(tree ?? []);
							let preselected = false;
							if (serviceId) {
								for (let i = 0; i < businessServices.length; i++) {
									if (businessServices[i].id === serviceId) {
										tree = servicesService.servicePreselection(tree, businessServices[i]);
										setSelectedServices([businessServices[i]]);
										preselected = true;
									}
								}
							}
							if (pet) {
								tree = servicesService.petPreselection(tree, pet);
								preselected = true;
							}
							if (preselected) {
								setCurrentLevel(tree ?? []);
							} else {
								showTreeRoot(tree ?? []);
							}
							if (!serviceId) {
								autoSelectIfSingleService(tree ?? []);
							}
						}
					})
					.catch(
						({
							response: {
								data: { message },
							},
						}) => {
							dialog
								.withTitle(t("Unable to load the services"))
								.withMessage(message)
								.withAction(() => props.history.goBack())
								.show();
							setLoading(false);
						}
					)
					.finally(() => {
						setReadyService(true);
						setLoading(false);
					});
			}
		}
	};

	useEffect(() => {
		if (business?.id) {
			getBusinessServices();
		}
	}, [selectedCategory, i18n?.language, business?.id]);

	useEffect(() => {
		if (!business?.id) return;
		packagesList(business.id, business.language)
		.then((res) => {
			const pkgs = res.data || [];
			const grouped = {};
			pkgs.forEach((pkg) => {
				const sid = pkg.service?.id;
				if (!sid) return;
				if (!grouped[sid]) grouped[sid] = [];
				grouped[sid].push(pkg);
			});
			const labelMap = {};
			Object.keys(grouped).forEach((sid) => {
				const label = buildPackageLabel(grouped[sid], sid);
				if (label) labelMap[sid] = label;
			});
				setPackageLabelMap(labelMap);
			})
			.catch(() => {
				// silently fail — package label is non-critical
			});
	}, [business?.id]);

	useEffect(() => {
		if (selectedCategory && !show) {
			setShow("services");
		}
	}, [selectedCategory, show]);

	const renderContent = () => {
		if (!business) return null;

		if (loading || !readyService) {
			return (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						height: "200px",
					}}>
					<CustomLoading />
				</div>
			);
		}

		if (!category && !selectedCategory) {
			return (
				<VendorCategorieScheduling
					selectCategory={handleCategorySelection}
					selectedPet={selectedPet}
					business={business}
					coupon={coupon}
				/>
			);
		}

		if (business?.sectorId === process.env.REACT_APP_PET_SECTOR_ID && !selectedPet) {
			if (showPetRegister) {
				return <VendorAddPet goToPetSelection={() => setShowPetRegister(false)} />;
			} else {
				return (
					<VendorRegisteredPet
						selectPet={(pet) => {
							setSelectedPet(pet);
						}}
						goToPetRegister={() => setShowPetRegister(true)}
					/>
				);
			}
		}

		if (category || selectedCategory) {
			if (show === "services" || !show) {
				return (
					<>
						<>
							<div>
								{search.length > 0
									? servicesTree
											.sort((a, b) => a.name.localeCompare(b.name))
											.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
											.map((item) => <div key={item.id}>{renderBranch(item)}</div>)
									: services?.length > 0
									? treeView
										? servicesTree.map((item) => <div key={item.id}>{renderBranch(item)}</div>)
										: currentLevel?.length > 0
											? renderLevel()
											: !loading && (
											<div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
												{t("No services available")}
											</div>
											)
									: !loading && (
										<div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
											{t("No services available")}
										</div>
									)}
							</div>
						</>
					</>
				);
			}
		}

		return null;
	};

	return (
		<>
			<ModalBottom
				style={{
					maxWidth: "480px",
					margin: "0 auto",
					width: "100%",
					flex: 1,
					position: "relative",
					paddingBottom: me?.name ? 55 : 45,
				}}
				showVendorDescription={showVendorDescription}
				setShowVendorDescription={setShowVendorDescription}
				title={getTitle(show)}
				containerButtonStyle={{
					position: "fixed",
					bottom: me?.name ? 55 : 45,
					backgroundColor: "#FDFCF8",
					maxWidth: "480px",
					left: 0,
					right: 0,
					margin: "0 auto",
				}}
				showFullAddress={showFullAddress}
				user={user}
				activeButton={levelPath?.length > 0 || selectedServices?.length > 0}
				animate={animationTrigger}
				showBackButton={shouldShowBackButton()}
				onBackClick={handleGoBack}
				buttonCustom={() => {
					if (showVendorDescription) {
						return null;
					}
					return (
						<>
							<div className={classes.selectedServicesContainer}>
									<>
										{(selectedServices?.length > 0 || levelPath?.length > 0) && (
											<div className={classes.selectedServicesWrapper}>
												<div
													ref={selectedServicesScrollRef}
													className={`${classes.selectedServicesScrollContainer} ${classes.noScrollBar}`}>
													<FeaturesSelected
														features={selectedServices}
														handleDelete={removeSelectedService}
														currentIndex={currentIndex}
														setCurrentIndex={setCurrentIndex}
														levelPath={levelPath}
														setLevelPath={handleSetLevelPath}
														setCurrentLevel={handleSetCurrentLevel}
														showPath={true}
														serviceLayout={true}
														isOld={false}
														showCheck={true}
													/>
												</div>
												{selectedServices?.length > 0 && (
													<div className={classes.selectedServicesCounter}>
														<span className={classes.selectedServicesCounterText}>
															{selectedServices?.length}{" "}
															{selectedServices?.length === 1 ? t("selected service") : t("selected services")}:
														</span>
													</div>
												)}
											</div>
										)}
										{isLastServiceLevel() && (
											<div className={classes.containerButtonsServices}>
												{showButtonSelectServices() && (
													<PurpleButton
														variant="contained"
														className={classes.buttonSelectServices}
														onClick={() => {
															handleSelectMoreServices();
														}}>
														{t("Select more services")}
													</PurpleButton>
												)}
												<ScheduleDiv
													business={false}
													handleClick={handleSchedule}
													label={showButtonSelectServices() ? t("View schedules") : t("View dates and times")}
													textTransform="none"
												/>
											</div>
										)}
									</>
							</div>
						</>
					);
				}}>
				{renderContent()}
			</ModalBottom>

			<ErrorDialog
				onOpen={openError}
				message={t("Selected Service")}
				onOk={() => {
					setOpenError(false);
				}}
				title={t("Attention")}
			/>
		</>
	);
};
export default withRouter(VendorCategoryServices);
